export default __webpack_public_path__ + "img/caikuma_06_reverse.2dadb927.webp";